module.exports = __webpack_public_path__ + "static/media/colheitadeira.4d2c3527.svg";